<script setup>
import { browsersRegex } from 'virtual:supported-browsers'

const isSupported = ref()
isSupported.value = browsersRegex.test(navigator.userAgent)

const { t } = useI18n()
</script>

<template>
  <DSAlert
    v-if="!isSupported"
    type="warning"
    no-close
  >
    {{ t('We have detected that you may be using an outdated or unsupported browser.') }}
    {{ t('In order to ensure the best possible TeamUp experience, including all the latest features, please make sure your browser and operating system are up-to-date.') }}
    <i18n-t
      tag="span"
      keypath="Please see our {link} for details."
    >
      <template #link>
        <a
          href="https://support.goteamup.com/why-doesnt-teamup-work-on-my-browser"
          class="text-text-500 fw-600"
          target="_blank"
        >{{ t('support guide') }}</a>
      </template>
    </i18n-t>
  </DSAlert>
</template>

<i18n>
{
  "en-us": {
    "We have detected that you may be using an outdated or unsupported browser.": "We have detected that you may be using an outdated or unsupported browser.",
    "In order to ensure the best possible TeamUp experience, including all the latest features, please make sure your browser and operating system are up-to-date.": "In order to ensure the best possible TeamUp experience, including all the latest features, please make sure your browser and operating system are up-to-date.",
    "Please see our {link} for details.": "Please see our {link} for details.",
    "support guide": "support guide"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "We have detected that you may be using an outdated or unsupported browser.": "Wir haben festgestellt, dass Sie möglicherweise einen veralteten oder nicht unterstützten Browser verwenden.",
  "In order to ensure the best possible TeamUp experience, including all the latest features, please make sure your browser and operating system are up-to-date.": "Um das bestmögliche TeamUp-Erlebnis, einschließlich aller neuesten Funktionen, zu gewährleisten, stellen Sie bitte sicher, dass Ihr Browser und Ihr Betriebssystem auf dem neuesten Stand sind.",
  "Please see our {link} for details.": "Weitere Informationen finden Sie in unserem {link}.",
  "support guide": "Support-Leitfaden"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "We have detected that you may be using an outdated or unsupported browser.": "Nous avons détecté que vous utilisez peut-être un navigateur obsolète ou non pris en charge.",
  "In order to ensure the best possible TeamUp experience, including all the latest features, please make sure your browser and operating system are up-to-date.": "Afin de garantir la meilleure expérience TeamUp possible, y compris toutes les dernières fonctionnalités, veuillez vous assurer que votre navigateur et votre système d'exploitation sont à jour.",
  "Please see our {link} for details.": "Veuillez consulter notre {link} pour plus de détails.",
  "support guide": "guide d'assistance"
}
</i18n>

<i18n locale="es" lang="json">
{
  "We have detected that you may be using an outdated or unsupported browser.": "Hemos detectado que podría estar utilizando una versión obsoleta o no admitida de su navegador.",
  "In order to ensure the best possible TeamUp experience, including all the latest features, please make sure your browser and operating system are up-to-date.": "Para disfrutar de la mejor experiencia de TeamUp y de las últimas funciones al completo, asegúrese de que su navegador y su sistema operativo estén actualizados.",
  "Please see our {link} for details.": "Consulte {link} para obtener más información.",
  "support guide": "guía de asistencia"
}
</i18n>
